import popsss from 'lib/popsss';
import { urlJoin } from '../../utils';

export const WIDGET_CLEAR = 'WIDGET_CLEAR';
export const WIDGET_CLEAR_BY_IDS = 'WIDGET_CLEAR_BY_IDS';
export const WIDGET_LOAD = 'WIDGET_LOAD';
export const WIDGET_LOAD_FAIL = 'WIDGET_LOAD_FAIL';
export const PROFILE_IMAGES_UPDATE = 'PROFILE_IMAGES_UPDATE';

export const clearWidgetsByIds = (ids) => (dispatch) =>
  dispatch({ type: WIDGET_CLEAR_BY_IDS, ids });

export function loadWidgets(
  id,
  widgetIds = null,
  params = {},
  sourceUrl = './',
) {
  return (dispatch) => {
    popsss
      .getJSON(urlJoin(sourceUrl, 'widget_data'), {
        id,
        widget_ids: widgetIds !== null ? JSON.stringify(widgetIds) : undefined,
        params: JSON.stringify(params),
      })
      .done((result) =>
        dispatch({ type: WIDGET_LOAD, widgets: result.widgets }),
      )
      .fail(() => dispatch({ type: WIDGET_LOAD_FAIL }));
  };
}

export function reloadWidgets(id, params = {}, sourceUrl = undefined) {
  return (dispatch) => {
    dispatch({ type: WIDGET_CLEAR });
    dispatch(loadWidgets(id, null, params, sourceUrl));
  };
}

export function reloadWidgetsByIds(
  id,
  widgetIds,
  params = {},
  sourceUrl = undefined,
) {
  return (dispatch) => {
    dispatch(clearWidgetsByIds(widgetIds));
    dispatch(loadWidgets(id, widgetIds, params, sourceUrl));
  };
}

export const WIDGET_CHANGE_VALUE = 'WIDGET_CHANGE_VALUE';
export const WIDGET_UPDATE_BACKEND = 'WIDGET_UPDATE_BACKEND';
export const WIDGET_UPDATE_VALUE = 'WIDGET_UPDATE_VALUE';
export const WIDGET_UPDATE_START = 'WIDGET_UPDATE_START';
export const WIDGET_UPDATE_SUCCESS = 'WIDGET_UPDATE_SUCCESS';
export const WIDGET_UPDATE_FAIL = 'WIDGET_UPDATE_FAIL';

export const changeValue = (id, name, value) => ({
  type: WIDGET_CHANGE_VALUE,
  name,
  value,
});

export const updateValue = (id, name, value, callback, sourceUrl) => {
  return {
    type: WIDGET_UPDATE_BACKEND,
    id,
    name,
    value,
    callback,
    sourceUrl,
    immediateUpdate: true,
    withSaving: true,
  };
};

export const updateAction = (
  id,
  name,
  action,
  withSaving,
  callback,
  sourceUrl,
) => {
  return {
    type: WIDGET_UPDATE_BACKEND,
    id,
    name,
    value: action,
    callback,
    immediateUpdate: false,
    withSaving,
    sourceUrl,
  };
};

export const WIDGET_SET_ERRORS = 'WIDGET_SET_ERRORS';

export const setErrors = (errors) => ({ type: WIDGET_SET_ERRORS, errors });

export function getProfileId(state) {
  return state.profile.id;
}

export function refreshImages(id) {
  return (dispatch, getState) => {
    const profileID = id || getProfileId(getState());
    if (profileID) {
      popsss
        .getJSON(`/api/profile/v1/${profileID}/all_images`)
        .done((result) =>
          dispatch({ type: PROFILE_IMAGES_UPDATE, images: result.images }),
        );
    }
  };
}

export function refreshMyImages(id) {
  return (dispatch, getState) => {
    const profileID = id || getProfileId(getState());
    if (profileID) {
      popsss
        .getJSON(`/api/my/profile/v1/${profileID}/all_images`)
        .done((result) =>
          dispatch({ type: PROFILE_IMAGES_UPDATE, images: result.images }),
        );
    }
  };
}
